import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { jwtDecode } from 'jwt-decode';
import { getCookie, resetTokensAndSendToLogin, setCookie } from 'helpers/cookies';
import blobErrorToObject from 'helpers/blobErrorToObject';
import users from './users';
import { ISearchContextResult } from 'interfaces/ISearch';
import { CancelToken } from 'axios';
import { functionCollectBrowserData } from 'helpers/browserData/functionCollectBrowserData';
import { refresTokensHandle } from 'helpers/tokens';

const correctHeaders = window.location?.href?.includes('localhost:3000')
  ? { "x-forwarded-for": "0.0.0.0", "Access-Control-Allow-Origin": "*"}
  : { "Access-Control-Allow-Origin": "*" };

const searcherTemplate = axios.create({
  baseURL: (window as any).REACT_APP_SEARCHER_API !== 'REPLACE_REACT_APP_SEARCHER_API' ? (window as any).REACT_APP_SEARCHER_API : process.env.REACT_APP_SEARCHER_API || 'http://localhost:8070/api',
  // withCredentials: true,
  headers: correctHeaders,
});

searcherTemplate.interceptors.request.use(async(config: InternalAxiosRequestConfig) => {
  let accessToken = getCookie('athena-token');
  let decodeInfo: any;
  if (accessToken) {
    try {
      decodeInfo = jwtDecode(accessToken);
    } catch (error) {
      Promise.reject('Error decoding token');
    }
    const expTime = decodeInfo?.exp && decodeInfo.exp * 1000;
    const curTime = new Date().getTime();

    if (expTime && expTime - curTime <= 50000) {
      const refresh_token = getCookie('refresh_token');      
      if (refresh_token) {
        try {
          const newTokens = await refresTokensHandle(refresh_token);
          accessToken = newTokens.access_token;
        } catch (error) {
          Promise.reject('Error refreshing tokens');
          resetTokensAndSendToLogin();
        };
      };
    };

    config.headers!.Authorization = `Bearer ${accessToken}`
  } else {
    setCookie('athena-token', '', 1);
  }
  return config;
});

let cntTryingUpdateFingerprint = 0;

searcherTemplate.interceptors.response.use(( response: AxiosResponse ) => {
  return response
}, async (error: AxiosError<any>) => {
  if (error.response?.status === 401 && cntTryingUpdateFingerprint < 1) {
    cntTryingUpdateFingerprint++;

    try {
      const formData = new FormData();
      const browserData = await functionCollectBrowserData();
      formData.append('browser_data', JSON.stringify(browserData) || '');

      const freshTokens = await users.updateFingerprint(formData);
      setCookie('athena-token', freshTokens.data.access_token, 1);
      setCookie('refresh_token', freshTokens.data.refresh_token, 1);

      return searcherTemplate.request(error.request.responseURL);
    } catch {
      resetTokensAndSendToLogin();
    }
  } else if (cntTryingUpdateFingerprint >= 1) {
    resetTokensAndSendToLogin();
  };

  if (error?.response?.data.constructor.name === 'Blob'){
    error.response.data = await blobErrorToObject(error?.response?.data)
  };
  return Promise.reject(error)
});

const searchDocumentsByContent = (room_id: string, search: string, sourceToken?: CancelToken, folder_id?: string | null) =>
  searcherTemplate.get<ISearchContextResult[]>(`/search/${room_id}/`, {
    cancelToken: sourceToken,
    params: {
      search,
      ...(folder_id ? { folder_id } : {}),
    },
  });

const searcher = {
  searchDocumentsByContent,
};

export default searcher;
